/* LMM T8/T5 predictive corrections and search routing.
   2026-07-11: Karten-Injektion (tubeCards/patchCollectionPage) + Header-/Sidebar-Patches
   ENTFERNT — die Bauform-/Längen-Grids rendert jetzt sections/lmm-tube-category-grid.liquid
   serverseitig (Templates led-roehren/t8/t5), Menü + Sidebar pflegen lmm-header.liquid
   (data-lmm-menu) und lmm-category-tree.liquid. Hier verbleibt nur das Such-Routing. */
(function () {
  'use strict';
  var H = window.LMMTubeHierarchy, data = H && H.data;
  if (!H || !data) return;
  var esc = H.esc, norm = H.norm, countMarkup = H.countMarkup;
  function patchPredictive(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.lmm-intent-category, .lmm-intent-suggestion').forEach(function (row) {
      var strong = row.querySelector('strong'), a = row.querySelector('a[href]'); if (!strong || !a) return;
      var text = norm(strong.textContent), item = text === 't8 led roehren' ? data.t8 : text === 't5 led roehren' ? data.t5 : null;
      if (!item || row.dataset.lmmTubePatched === item.handle) return;
      row.dataset.lmmTubePatched = item.handle; a.setAttribute('href', H.previewUrl(item.url));
      var c = row.querySelector('.lmm-intent-category__count'); if (c && Number(item.count) > 0) c.textContent = Number(item.count).toLocaleString('de-DE') + ' Artikel';
      var note = row.querySelector('small'); if (note) note.textContent = item.badge;
    });
  }
  function routedParent(raw) {
    var q = norm(raw), hasT8 = /\bt8\b|\bg13\b/.test(q), hasT5 = /\bt5\b|\bg5\b/.test(q);
    var ledTube = /led\s*(roehre|roehren|tube|tubes)|ledroehre|ledroehren/.test(q) || (/\bled\b/.test(q) && (hasT8 || hasT5));
    if (!ledTube || hasT8 === hasT5 || /\b(osram|philips|ledvance|sylvania|radium|modee|patron)\b/.test(q)) return '';
    var hasLength = hasT8 ? /\b(60|90|120|150)\s*cm\b|\b(600|900|1200|1500)\s*mm\b/.test(q) :
      /\b(549|849|1149|1449)\s*mm\b|\b(54[.,]9|84[.,]9|114[.,]9|144[.,]9)\s*cm\b/.test(q);
    if (hasLength) return '';
    var u = new URL(hasT8 ? '/collections/t8-led-roehren' : '/collections/t5-led-roehren', location.origin);
    if (/\b827\b|\b830\b|warm\s*weiss|warmweiss|warm white/.test(q)) { u.searchParams.append('filter.p.m.specs.kelvin','2700'); u.searchParams.append('filter.p.m.specs.kelvin','3000'); }
    else if (/\b840\b|neutral\s*weiss|neutralweiss|cool white/.test(q)) u.searchParams.append('filter.p.m.specs.kelvin','4000');
    else if (/\b865\b|kalt\s*weiss|kaltweiss|tageslicht|daylight/.test(q)) u.searchParams.append('filter.p.m.specs.kelvin','6500');
    if (/\bdimmbar\b|\bdimmable\b|\bdimmen\b/.test(q) && !/nicht\s+dimmbar/.test(q)) u.searchParams.append('filter.p.m.specs.dimmable','true');
    return H.previewUrl(u.pathname + u.search);
  }
  function captureSubmit(event) {
    var form = event.target; if (!(form instanceof HTMLFormElement) || !form.matches('form[role="search"], .lmmh-search__form')) return;
    var input = form.querySelector('input[name="q"]'), target = input && routedParent(input.value); if (!target) return;
    event.preventDefault(); event.stopImmediatePropagation(); location.assign(target);
  }
  function captureKey(event) {
    if (event.key !== 'Enter' || event.isComposing || !(event.target instanceof HTMLInputElement) || event.target.name !== 'q') return;
    var form = event.target.closest('form'); if (!form || !form.matches('form[role="search"], .lmmh-search__form') || form.querySelector('[aria-selected="true"] a[href]')) return;
    var target = routedParent(event.target.value); if (!target) return;
    event.preventDefault(); event.stopImmediatePropagation(); location.assign(target);
  }
  function boot() {
    patchPredictive(document);
    window.addEventListener('submit', captureSubmit, true); window.addEventListener('keydown', captureKey, true);
    if (window.MutationObserver) new MutationObserver(function (mutations) {
      mutations.forEach(function (m) { m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) { patchPredictive(node); }
      }); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot, { once: true }) : boot();
})();
